<template>
  <div class="business_bg">
    <div class="topview">
      <span class="top">企业管理</span>
    </div>
    <div class="lowerview">
      <div class="selectview">
        <el-row>
          <el-col :span="22">
            <ul>
              <li>
                <el-input
                  placeholder="请输入企业名称"
                  v-model="business_name"
                  clearable
                ></el-input>
              </li>
              <li>
                <el-select
                  v-model="business_type"
                  clearable
                  placeholder="请选择企业类型"
                >
                  <el-option
                    v-for="item in business_typelist"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </li>
              <li>
                <el-button
                  type="primary"
                  class="querybutton"
                  @click="querybtnClick()"
                  >查询</el-button
                >
              </li>
              <div style="clear: both"></div>
            </ul>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              class="addbutton"
              @click="addbtnClick()"
              :disabled="addPrivilege == 1"
              :class="[addPrivilege == 1 ? 'active' : '']"
              >新建 +</el-button
            >
          </el-col>
        </el-row>
      </div>
      <div class="table_bg">
        <el-table
          :data="tableData"
          border
          :header-cell-style="{ background: '#f3f3f3', color: '#333333' }"
          style="width: 100%"
        >
          <el-table-column label="序号" width="80" prop="id">
            <template slot-scope="scope">
              <span style="margin-left: 10px">{{ scope.row.id }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业名称" prop="name" show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <el-table-column label="企业类型" prop="type">
            <template slot-scope="scope">
              <span v-if="scope.row.type == '1'">独立运营</span>
              <span v-else-if="scope.row.type == '2'">合作运营</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column label="联系人" width="100" prop="contact_name">
            <template slot-scope="scope">
              <span>{{ scope.row.contact_name | defaultValFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" prop="contact_phone" width="120">
            <template slot-scope="scope">
              <span>{{ scope.row.contact_phone | defaultValFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="地址" show-overflow-tooltip prop="address">
            <template slot-scope="scope">
              <span>{{ scope.row.address | defaultValFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="运营商ID" prop="operator_id">
            <template slot-scope="scope">
              <span>{{ scope.row.operator_id | defaultValFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="运营商电话2"
            width="120"
            prop="contact_phone_two"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.contact_phone_two | defaultValFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="备注"
            show-overflow-tooltip
            prop="operator_remark"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.operator_remark | defaultValFilter }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                class="editbutton"
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                :disabled="editPrivilege == 1"
                :class="[editPrivilege == 1 ? 'active' : '']"
                >编辑</el-button
              >
              <el-button
                class="deletebutton"
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
                :disabled="deletePrivilege == 1"
                :class="[deletePrivilege == 1 ? 'active' : '']"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="cutpagesview">
        <el-pagination
          class="pageinclass"
          background
          @current-change="handleCurrentChange"
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>
    </div>
    <!-- 新建企业 -->
    <el-dialog
      :visible.sync="newStationDialog"
      customClass="new-station-dialog"
      @close="cancelClick"
      :close-on-click-modal="false"
    >
      <p class="title">{{ title }}</p>
      <div class="line"></div>
      <div class="new-station-parameter">
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">企业名称：</span>
          <el-input
            v-model="add_businessname"
            clearable
            placeholder="请输入企业名称"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">企业类型：</span>
          <el-select
            v-model="add_stationType"
            clearable
            placeholder="请选择企业类型"
          >
            <el-option
              v-for="item in add_stationTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">运营商ID：</span>
          <el-input
            v-model="operator_id"
            clearable
            maxlength="9"
            placeholder="请输入运营商ID"
          ></el-input>
          <el-tooltip placement="left-start">
            <div slot="content" style="line-height: 26px; font-size: 16px">
              运营商ID使用组织机构代码（去掉“-”符号的9位字符，<br />对于新营业执照（三码合一）其组织机构代码为社会信用<br />代码去掉前八位和最后一位后的中间的数字）
            </div>
            <span class="tool-tip">!</span>
          </el-tooltip>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">联系人：</span>
          <el-input
            v-model="add_contractman"
            clearable
            placeholder="请输入联系人"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">联系电话1：</span>
          <el-input
            v-model="add_telephone"
            clearable
            placeholder="请输入联系电话"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="name">联系电话2：</span>
          <el-input
            v-model="contact_phone_two"
            maxlength="32"
            clearable
            placeholder="请输入联系电话"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">地址：</span>
          <el-input
            v-model="add_address"
            clearable
            placeholder="请输入地址"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="star ml-13">*</span>
          <span class="name">加密密钥：</span>
          <el-input
            v-model="operator_secret"
            show-password
            clearable
            placeholder="请输入密码"
          ></el-input>
        </div>
        <div class="parameter">
          <span class="name">备注：</span>
          <el-input
            v-model="operator_remark"
            maxlength="255"
            clearable
            placeholder="请输入备注"
          ></el-input>
        </div>
        <div class="parameter-btn">
          <el-button class="cancel" @click="cancelClick()">取消</el-button>
          <el-button class="confirm" @click="confirmClick()">确认</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { truncate } from "fs";
import { type } from "os";
export default {
  data() {
    return {
      page:1,
      pageSize:12,
      total: 0, //这个是总共有多少条数据
      newStationDialog: false,
      templateTitle: "新建企业",
      business_name: "",
      business_type: "",
      business_typelist: [
        {
          value: 1,
          label: "独立运营",
        },
        {
          value: 2,
          label: "合作运营",
        },
      ],
      id: "",
      tableData: [],
      title: "",
      add_businessname: "",
      add_contractman: "",
      add_telephone: "",
      add_address: "",
      add_stationType: "",
      add_stationTypeList: [
        {
          value: 1,
          label: "独立运营",
        },
        {
          value: 2,
          label: "合作运营",
        },
      ],
      EnterpriseRow: {},
      deleteRow: {},
      addPrivilege: 1, //新建
      editPrivilege: 1, //编辑
      deletePrivilege: 1, //删除
      // 互联互通
      operator_id: "", //运营商 ID
      contact_phone_two: "", //运营商电话2
      operator_remark: "", //备注
      operator_secret: "", //密码
    };
  },
  beforeRouteEnter(to, from, next) {
    window.document
      .querySelector("body")
      .setAttribute("style", "background-color:#f8f8f8");
    window.document
      .querySelector("body")
      .setAttribute("style", "background-image:none");
    window.document.body.style.backgroundColor = "#efefef";
    next();
  },
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = "#001928";
    next();
  },
  mounted() {
    // console.log(this.$store.state.role);
    let role = [];
    role = this.$store.state.role;
    for (let i in role) {
      if (role[i].view_name == "系统管理") {
        for (let j in role[i].chlid) {
          if (role[i].chlid[j].view_name == "企业管理") {
            for (let m in role[i].chlid[j].method) {
              if (role[i].chlid[j].method[m].method_name == "新建企业") {
                this.addPrivilege = 0;
              } else if (role[i].chlid[j].method[m].method_name == "编辑企业") {
                this.editPrivilege = 0;
              } else if (role[i].chlid[j].method[m].method_name == "删除企业") {
                this.deletePrivilege = 0;
              }
            }
          }
        }
      }
    }

    this.querybtnClick();
  },
  methods: {
    addbtnClick() {
      this.title = "新建企业";
      this.newStationDialog = true;
    },
    handleEdit(index, row) {
      this.getEnterprise(row.id);
      this.id = row.id;
      this.title = "编辑企业";
    },
    handleDelete(index, row) {
      this.deleteEnterprise(row.id);
    },
    handleCurrentChange(data) {
     this.page=data
     this.querybtnClick()
    },

    /**
     * 获取企业列表数据
     */
    querybtnClick() {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getEnterprises",
        page:this.page,
        page_size:this.pageSize
      };
      if (this.business_name != "" && this.business_name != null) {
        params.keyword = this.business_name;
      }
      if (this.business_type != "" && this.business_type != null) {
        params.type = this.business_type;
      }
      this.$api({
        method: "post",
        url: "/api.php/Enterprise/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            this.tableData = su.data.list;
            this.total = this.tableData.length;

          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    cancelClick() {
      this.newStationDialog = false;
      this.add_businessname = "";
      this.add_stationType = "";
      this.add_contractman = "";
      this.add_telephone = "";
      this.add_address = "";
      this.id = "";

      this.operator_id = "";
      this.contact_phone_two = "";
      this.operator_remark = "";
      this.operator_secret = "";
    },
    confirmClick() {
      if (
        this.add_businessname != "" &&
        this.add_stationType != "" &&
        this.add_contractman != "" &&
        this.add_telephone != "" &&
        this.add_address != ""
      ) {
        if (this.ValidatePhone(this.add_telephone) == false) {
          this.$message.warning("请填写正确的联系电话");
          return;
        } else {
          this.saveinformation();
        }
      } else {
        this.$message.warning("请将信息填写完成");
        return;
      }
    },
    ValidatePhone(val) {
      var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/; //手机号码
      var isMob = /^0?1[3|4|5|8][0-9]\d{8}$/; // 座机格式
      if (isMob.test(val) || isPhone.test(val)) {
        return true;
      } else {
        return false;
      }
    },

    /**
     *
     * 新增企业、编辑企业信息（id>0为编辑）
     */
    saveinformation() {
      if (this.add_businessname.indexOf(" ") >= 0) {
        this.$message.warning("企业名称不能含空格！");
        return;
      } else if (this.add_contractman.indexOf(" ") >= 0) {
        this.$message.warning("联系人不能含空格！");
        return;
      } else if (this.add_address.indexOf(" ") >= 0) {
        this.$message.warning("地址不能含空格！");
        return;
      } else if (isEmpty(this.operator_id)) {
        this.$message.warning("请输入运营商ID！");
        return;
      } else if (this.operator_id.indexOf(" ") >= 0) {
        this.$message.warning("运营商ID不能含空格！");
        return;
      } else if (isEmpty(this.operator_secret)) {
        this.$message.warning("请输入密码！");
        return;
      } else if (this.operator_secret.indexOf(" ") >= 0) {
        this.$message.warning("密码不能含空格！");
        return;
      }
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "saveEnterprise",
        operator_id: this.operator_id,
        contact_phone_two: this.contact_phone_two,
        operator_remark: this.operator_remark,
        operator_secret: this.operator_secret,
      };
      if (this.id != "" && this.id != null) {
        params.id = this.id;
      }
      if (this.add_businessname != "" && this.add_businessname != null) {
        params.name = this.add_businessname;
      }
      if (this.add_stationType != "" && this.add_stationType != null) {
        if (this.add_stationType == "独立运营") {
          params.type = 1;
        } else if (this.add_stationType == "合作运营") {
          params.type = 2;
        } else {
          params.type = this.add_stationType;
        }
      }
      if (this.add_contractman != "" && this.add_contractman != null) {
        params.contact_name = this.add_contractman;
      }
      if (this.add_telephone != "" && this.add_telephone != null) {
        params.contact_phone = this.add_telephone;
      }
      if (this.add_address != "" && this.add_address != null) {
        params.address = this.add_address;
      }
      // console.log("省份传参--：", params);
      this.$api({
        method: "post",
        url: "/api.php/Enterprise/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          // console.log("新增----",su)
          if (su.data.code == 1) {
            this.newStationDialog = false;
            this.querybtnClick();
            this.$message.success(su.data.message);
            this.add_businessname = "";
            this.add_contractman = "";
            this.add_telephone = "";
            this.add_address = "";
            this.add_stationType = "";
            this.id = "";

            this.operator_id = "";
            this.contact_phone_two = "";
            this.operator_remark = "";
            this.operator_secret = "";
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },
    /**
     * 点击编辑获取企业信息
     */
    getEnterprise(id) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "getEnterprise",
        id: id,
      };

      this.$api({
        method: "post",
        url: "/api.php/Enterprise/index",
        data: params,
        transformRequest: [
          (data) => {
            let ret = "";
            for (let it in data) {
              ret +=
                encodeURIComponent(it) +
                "=" +
                encodeURIComponent(data[it]) +
                "&";
            }
            return ret;
          },
        ],
      })
        .then((su) => {
          if (su.data.code == 1) {
            var list = su.data.list;
            this.add_businessname = list.name;
            this.add_contractman = list.contact_name;
            this.add_telephone = list.contact_phone;
            this.add_address = list.address;

            this.operator_id = list.operator_id;
            this.contact_phone_two = list.contact_phone_two;
            this.operator_remark = list.operator_remark;
            this.operator_secret = list.operator_secret;

            // this.add_stationType = list.type;
            if (list.type == "1") {
              this.add_stationType = "独立运营";
            } else if (list.type == "2") {
              this.add_stationType = "合作运营";
            }
            this.newStationDialog = true;
          } else if (su.data.code == 0) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == -1) {
            this.$message.warning(su.data.message);
          } else if (su.data.code == 300) {
            localStorage.clear();
            this.$router.push("/login");
            this.$message.warning(su.data.message);
          }
        })
        .catch((err) => {});
    },

    /**
     * 删除
     */
    deleteEnterprise(id) {
      let params = {
        uid: localStorage.getItem("uid"),
        token: localStorage.getItem("token"),
        action: "deleteEnterprise",
        id: id,
      };
      this.$confirm("确定删除", "删除", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "",
      })
        .then(() => {
          this.$api({
            method: "post",
            url: "/api.php/Enterprise/index",
            data: params,
            transformRequest: [
              (data) => {
                let ret = "";
                for (let it in data) {
                  ret +=
                    encodeURIComponent(it) +
                    "=" +
                    encodeURIComponent(data[it]) +
                    "&";
                }
                return ret;
              },
            ],
          })
            .then((su) => {
              if (su.data.code == 1) {
                this.querybtnClick();
              } else if (su.data.code == 0) {
                this.$message.warning(su.data.message);
              } else if (su.data.code == -1) {
                this.$message.warning(su.data.message);
              } else if (su.data.code == 300) {
                localStorage.clear();
                this.$router.push("/login");
                this.$message.warning(su.data.message);
              }
            })
            .catch((err) => {});
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.business_bg {
  margin: 1%;
  width: 98%;
}
.topview {
  height: 46px;
  color: #0071bd;
  background-color: white;
  text-align: left;
  span {
    margin-left: 13px;
    line-height: 46px;
    font-weight: bold;
  }
}
.selectview {
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    float: left;
    // display: inline-block;
    margin: 5px 10px 5px 0;
  }
}
.lowerview {
  overflow: hidden;
  clear: both;
  background-color: white;
  margin-top: 10px;
  padding: 1%;
}
.querybutton {
  width: 80px;
  // margin: 5px 5px 5px 0px;
  text-align: center;
  display: inline-block;
  background-color: #0071bd;
  color: white;
  border: none;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #0071bd;
    border-color: #0071bd;
    color: #fff;
  }
}
.business_bg {
  .querybutton:active {
    background-color: #409eff;
  }
}
.addbutton {
  width: 80px;
  // margin: 5px 5px 5px 0px;
  text-align: center;
  display: inline-block;
  background-color: #f15500;
  color: white;
  border: none;
  .el-button--primary:focus,
  .el-button--primary:hover {
    background: #f15500;
    border-color: #f15500;
    color: #fff;
  }
}
.addbutton.active {
  background-color: #a5a5a5;
}
.table_bg {
  margin-top: 15px;
}
.cutpagesview {
  margin: 20px 0;
  height: 30px;
}
.pageinclass {
  float: right;
}
.editbutton {
  background-color: #0071bd;
  color: #ffffff;
  border: none;
}
.editbutton.active {
  background-color: #a5a5a5;
}
.deletebutton {
  background-color: #009a5b;
  color: #ffffff;
  border: none;
}
.deletebutton.active {
  background-color: #a5a5a5;
}

.new-station-dialog {
  position: relative;
  overflow-x: hidden;
  .title {
    font-size: 18px;
    position: absolute;
    left: 16px;
    top: 16px;
    color: #0171bd;
  }
  .line {
    width: calc(100% + 40px);
    margin-left: -20px;
    margin-right: -20px;
    height: 1px;
    background-color: #eaeaea;
    margin-bottom: 30px;
  }
  .new-station-parameter {
    width: 100%;
    .parameter {
      width: 70%;
      height: 40px;
      line-height: 40px;
      text-align: right;
      margin-left: 15%;
      margin-bottom: 16px;
      position: relative;
      .star {
        color: #ea0000;
      }
      .tool-tip {
        margin-left: 10px;
        background-color: #ea0000;
        color: #ffffff;
        font-size: 22px;
        display: inline-block;
        width: 22px;
        height: 22px;
        line-height: 22px;
        border-radius: 50%;
        text-align: center;
        position: absolute;
        right: -30px;
        top: 9px;
      }
      .ml-13 {
        margin-left: 13px;
      }
      .ml-40 {
        margin-left: 40px;
      }
      .el-input,
      .el-select {
        width: 76%;
        float: right;
      }
    }
    .parameter-city {
      .el-input,
      .el-select {
        width: 40%;
      }
    }
    .parameter-btn {
      margin-top: 40px;
      text-align: center;
      .cancel {
        width: 26%;
        background-color: #0071bd;
        color: #ffffff;
        border: none;
        height: 40px;
      }
      .confirm {
        width: 26%;
        background-color: #02b36f;
        color: #ffffff;
        border: none;
        height: 40px;
      }
    }
  }
}
</style>
<style lang="scss">
.business_bg
  .el-table--enable-row-hover
  .el-table__body
  tr:hover
  > td
  .editbutton {
  background-color: #409eff;
  color: #ffffff;
}
</style>


// WEBPACK FOOTER //
// src/components/systemManagement/businessManagement.vue